import useAccountRepo from '@/composables/logged-in-user-account/account-repo';
import useAccountSlugs from '@/composables/logged-in-user-account/account-slug';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { computed } from 'vue';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { uploadFile } from '@/lib/image/image';

export default function useLoggedInUserAccount() {
  const accountRepo = useAccountRepo();
  const { loggedInUser } = useLoggedInUser();
  const { slugs } = useAccountSlugs();

  const loggedInUserAccount = computed(() => {
    if (loggedInUser.value === null || loggedInUser.value.account === undefined) {
      return { accountSettings: {}, companyImage: {}, goalSettings: {} };
    }

    const account = accountRepo.selectSingle(loggedInUser.value.account.uid);
    if (account === undefined) {
      return { accountSettings: {}, companyImage: {}, goalSettings: {} };
    }

    return account;
  });

  const uploadImage = (blob) => uploadFile(blob, () => {}).then((data) => {
    const companyImage = () => {
      if (loggedInUserAccount.value.companyImage === null) {
        return { blob: data.fileId, getURL: data.getURL };
      }
      return {
        uid: loggedInUserAccount.value.companyImage.uid,
        blob: data.fileId,
        getURL: data.getURL,
      };
    };
    return accountRepo.updateSingle({
      uid: loggedInUserAccount.value.uid,
      companyImage: companyImage(),
    }, { optimistic: false });
  });

  const deleteImage = () => {
    if (loggedInUserAccount.value.companyImage === null) {
      return new Promise((resolve) => {
        resolve();
      });
    }
    return accountRepo.updateSingle({
      uid: loggedInUserAccount.value.uid,
      companyImage: null,
    }, { optimistic: false });
  };

  const updateSingle = (entity, options, hookParameter) => {
    if (!isNullOrUndefined(entity.activeSlug)) {
      const existingSlug = slugs.value.find((s) => s.slug === entity.activeSlug.slug);
      if (existingSlug !== undefined) {
        entity.activeSlug = existingSlug;
      }
    }
    return accountRepo.updateSingle(entity, options, hookParameter);
  };

  return {
    loggedInUserAccount,
    uploadImage,
    deleteImage,
    updateSingle,
    getList: accountRepo.getList,
  };
}
